import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthFacade } from '../facades/auth.facade';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

export const adminGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return toObservable(authFacade.isLoading).pipe(
    filter(isLoading => !isLoading),
    map(() => {
      // A teacher may enter their shell only while their subscription is live.
      if (authFacade.isTeacher()) {
        if (authFacade.isSubscriptionActive()) {
          return true;
        }
        // Subscription expired/suspended — the academy is paused. Sent to an
        // info page OUTSIDE /teacher (and without guestGuard) to avoid a
        // guard ping-pong.
        return router.createUrlTree(['/subscription-inactive']);
      }

      // Otherwise redirect to the right place (or login if not authenticated)
      if (!authFacade.isAuthenticated()) {
        return router.createUrlTree(['/auth/login']);
      }

      if (authFacade.isSuperAdmin()) {
        return router.createUrlTree(['/admin']);
      }

      return router.createUrlTree(['/student/home']);
    })
  );
};
